import {
  createSlice,
  type PayloadAction,
  type Reducer,
} from '@reduxjs/toolkit';
import type { RootState } from '@root/store/store';

export const OVERLAY_SLICE_KEY = 'overlay';

export interface OverlaySliceState {
  visible: boolean;
  remainingTime: string;
  bettingRemainingTime: string;
}

export const initialState: OverlaySliceState = {
  visible: false,
  remainingTime: '0',
  bettingRemainingTime: '0',
};

const overlaySlice = createSlice({
  name: OVERLAY_SLICE_KEY,
  initialState,
  reducers: {
    setOverlayVisible: (state, action: PayloadAction<boolean>) => {
      state.visible = action.payload;
    },
    toggleOverlay: (state) => {
      state.visible = !state.visible;
    },
    setRemainingTime: (state, action: PayloadAction<string>) => {
      state.remainingTime = action.payload;
    },
    setBettingRemainingTime: (state, action: PayloadAction<string>) => {
      state.bettingRemainingTime = action.payload;
    },
  },
});

const overlayReducer = overlaySlice.reducer as Reducer;

export default overlayReducer;

export const overlaySelector = (state: RootState): OverlaySliceState =>
  state.overlay;

export const overlayActions = overlaySlice.actions;
